"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROGRAM_ID = void 0;
const consts_1 = require("../consts");
// This constant will not get overwritten on subsequent code generations and it's safe to modify it's value.
exports.PROGRAM_ID = consts_1.PROGRAM_ID_PUBKEY;
//# sourceMappingURL=programId.js.map